module.exports = __webpack_public_path__ + "static/media/vertical-ellipsis.97eb0ade.svg";